import { giftCategoryIdAtom } from '@activities/gift/GiftsActivity/fragments/GiftCategoryFragment/atoms/giftItemAtoms';
import BlankGift from '@components/blank/BlankGift';
import styled from '@emotion/styled';
import { useAtomValue } from 'jotai';

import GiftItem from '../GiftItem';
import PrepaidCardItem from '../PrepaidCardItem';
import useGiftItems from './hooks/useGiftItems';

function Contents() {
    const giftCategoryId = useAtomValue(giftCategoryIdAtom);
    const { items } = useGiftItems(giftCategoryId);
    if (items?.length === 0) {
        return (
            <BlankGift type='APPLY' />
        );
    }
    return (
        <Grid>
            {items?.map((item) => {
                if (item.giftItemType === 'PRODUCT') {
                    return <GiftItem giftItem={item} key={item.id} />;
                }
                return <PrepaidCardItem giftItem={item}
                    key={item.id} />;
            })}
            {/* <VisibleAction onVisible={fetchNext} /> */}
        </Grid>
    );
}

const Grid = styled.div`
    display: grid;
    grid-gap: 22px 24px;
    grid-template-columns: 1fr 1fr;
    padding: 36px 20px;
    width: 100%;
`;

export default Contents;
